import { useAnalyticsSales, useProducts } from '@/api';
import { MetricCard } from '@/components/atoms';
import { formatCurrency } from '@/lib/helpers';

export const ProductMetrics = () => {
  const { data } = useAnalyticsSales();

  const { data: products } = useProducts();

  const outOfStockProducts = products?.filter(
    (product) => product.quantity === 0
  );

  return (
    <div className="grid grid-cols-12 gap-2.5 col-span-1 row-span-4 md:row-span-2 xl:row-span-1">
      <MetricCard
        variant="primary"
        name="Total sales"
        value={formatCurrency(data?.totalSales || 0)}
        icon="Tag"
        className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
      />
      <MetricCard
        variant="blue"
        name="Total products"
        value={products?.length || 0}
        icon="MessagesSquare"
        className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
      />
      <MetricCard
        variant="amber"
        name="Out of stock"
        value={outOfStockProducts?.length || 0}
        icon="ShoppingBag"
        className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
      />
    </div>
  );
};
